/* dsp-swatches.js — decorates Dawn's pill variant picker without touching its snippets or JS:
   - adds data-dsp-swatch="<value>" to each Color/Colour pill label (profile-product.css maps names to hex)
   - appends the selected value to the option legend ("Color — Sport Grey")
   Re-runs after Dawn's product-info.js re-renders the picker (MutationObserver), idempotently. */
(function () {
  'use strict';
  var COLOR_OPTIONS = ['color', 'colour'];

  function decorate(root) {
    root.querySelectorAll('.product-form__input--pill').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var inputs = fieldset.querySelectorAll('input[type="radio"]');
      if (!legend || !inputs.length) return;

      var optionName = (inputs[0].dataset.optionName || legend.textContent || '').trim().toLowerCase();
      var isColor = COLOR_OPTIONS.indexOf(optionName) > -1;
      var selected = '';

      inputs.forEach(function (input) {
        var label = input.labels && input.labels[0];
        if (label && isColor && !label.hasAttribute('data-dsp-swatch')) label.setAttribute('data-dsp-swatch', input.value);
        if (input.checked) selected = input.value;
      });

      var span = legend.querySelector('.dsp-pill__value');
      if (!span) {
        span = document.createElement('span');
        span.className = 'dsp-pill__value';
        legend.appendChild(span);
      }
      var text = selected ? ' — ' + selected : '';
      if (span.textContent !== text) span.textContent = text;
    });
  }

  function init(picker) {
    if (picker.dataset.dspDecorated) return;
    picker.dataset.dspDecorated = '1';
    decorate(picker);
    picker.addEventListener('change', function (event) {
      if (event.target && event.target.type === 'radio') decorate(picker);
    });
    new MutationObserver(function () {
      decorate(picker);
    }).observe(picker, { childList: true, subtree: true });
  }

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('variant-selects') : []).forEach(init);
  }

  function start() {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('variant-selects')) init(node);
          else scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
